import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
const apiurl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ItemPriceService {

  constructor(private http: HttpClient,private errorHandler:ErrorHandlerService,) { }
    
      createItem(data: any): Observable<any> {
        return this.http.post<any>(`${apiurl}/pricenoti`, data).pipe(
          tap((response) => response),
          catchError((error) => this.errorHandler.handleError(error))
        );
      }
}
